import { FlexCell, FlexRow, Text } from '@epam/promo';
import { StatisticsTaskProps } from './StatisticsTask.model';
import css from './StatisticsTask.module.scss';

export const StatisticsTask = ({
  title,
  description,
  skipCount,
  failCount,
  isFailed,
  onTaskClick,
}: StatisticsTaskProps) => (
  <FlexCell
    cx={`${css['statistics-task__container']} ${isFailed && css.isFailed}`}
    onClick={onTaskClick}>
    <FlexRow>
      <FlexCell grow={5}>
        <Text cx={css['statistics-task__text']} size="30">
          {title}
        </Text>
        <Text cx={css['statistics-task__text']} size="24">
          {description}
        </Text>
      </FlexCell>
      <FlexCell grow={1}>
        <Text
          cx={`${css['statistics-task__count']} ${isFailed && css.isFailed}`}
          size="42">
          {isFailed ? failCount : skipCount}
        </Text>
      </FlexCell>
    </FlexRow>
  </FlexCell>
);
